(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greenleaf-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('greenleaf-shop-the-look')) {
    customElements.define('greenleaf-shop-the-look', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.root = (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/');
        this.status = this.querySelector('[role="status"]');
        this.cartLink = this.querySelector('.gl-stl__cart-link');
        this.cards = [...this.querySelectorAll('[data-stl-card]')];
        this.addEventListener('click', event => {
          const selection = event.target.closest('[data-stl-select]');
          if (selection && !this.busy) this.selectLook(selection.closest('[data-stl-card]'), true);
          const button = event.target.closest('[data-stl-add]');
          if (button && !button.disabled) this.addLook(button.closest('[data-stl-card]'));
        });
        this.refresh();
        this.onReturn = () => { if (!document.hidden && !this.busy) this.refresh(); };
        window.addEventListener('focus', this.onReturn);
        document.addEventListener('visibilitychange', this.onReturn);
      }
      disconnectedCallback() {
        window.removeEventListener('focus', this.onReturn);
        document.removeEventListener('visibilitychange', this.onReturn);
        this.initialized = false;
      }
      selectLook(card, moveFocus = false) {
        if (!card || card.hidden) return;
        this.cards.forEach(item => {
          const selected = item === card;
          item.classList.toggle('is-featured', selected);
          const selector = item.querySelector('[data-stl-select]');
          selector.hidden = selected;
          item.querySelectorAll('a').forEach(link => { link.tabIndex = selected ? 0 : -1; });
          item.querySelector('img').sizes = selected ? '(min-width: 750px) 600px, calc(100vw - 36px)' : '(min-width: 750px) 190px, 30vw';
        });
        this.syncJumpLinks();
        if (moveFocus) card.querySelector('[data-stl-add]').focus({ preventScroll: true });
      }
      async json(url, options = {}) {
        const response = await fetch(url, { credentials: 'same-origin', ...options });
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      }
      async variants(card, cache = new Map()) {
        const get = url => {
          const endpoint = new URL(url, location.origin);
          endpoint.pathname += '.js';
          endpoint.search = '';
          if (!cache.has(endpoint.href)) cache.set(endpoint.href, this.json(endpoint.href, { cache: 'no-store' }));
          return cache.get(endpoint.href);
        };
        const products = await Promise.all([get(card.dataset.plantUrl), get(card.dataset.potUrl)]);
        return products.map((product, index) => product.variants.find(variant => String(variant.id) === (index ? card.dataset.pot : card.dataset.plant)));
      }
      setPrice(card, variants) {
        const currency = this.dataset.currency;
        card.querySelector('[data-stl-price]').textContent = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency }).format((variants[0].price + variants[1].price) / 100);
      }
      syncJumpLinks() {
        const availableCards = this.cards.filter(card => !card.hidden);
        const visible = !this.hidden && availableCards.length > 0;
        this.classList.toggle('has-single-look', availableCards.length === 1);
        const card = this.cards.find(item => !item.hidden && item.classList.contains('is-featured')) || this.cards.find(item => !item.hidden);
        document.querySelectorAll('[data-stl-jump]').forEach(link => {
          if (visible && card?.dataset.jumpImage) {
            let image = link.querySelector('.gl-stl-jump__image');
            if (!image) {
              image = document.createElement('img');
              image.className = 'gl-stl-jump__image';
              image.alt = '';
              image.width = 64;
              image.height = 64;
              image.decoding = 'async';
              link.prepend(image);
            }
            if (image.getAttribute('src') !== card.dataset.jumpImage) image.src = card.dataset.jumpImage;
          }
          link.hidden = !visible;
        });
      }
      applyAvailability() {
        const selected = this.cards.find(card => card.classList.contains('is-featured'));
        const seen = new Set();
        let count = 0;
        this.cards.forEach(card => {
          const pair = card.dataset.plant + ':' + card.dataset.pot;
          const visible = card.stlAvailable === true && !seen.has(pair) && count < 4;
          card.hidden = !visible;
          card.querySelector('[data-stl-add]').disabled = !visible || !!this.busy;
          if (visible) { seen.add(pair); count++; }
        });
        this.hidden = count === 0;
        this.selectLook(selected && !selected.hidden ? selected : this.cards.find(card => !card.hidden));
        this.syncJumpLinks();
      }
      refresh() {
        if (this.refreshing) return this.refreshing;
        this.refreshing = this.refreshAvailability().finally(() => { this.refreshing = null; });
        return this.refreshing;
      }
      async refreshAvailability() {
        const cache = new Map();
        this.cards.forEach(card => { card.querySelector('[data-stl-add]').disabled = true; });
        await Promise.all(this.cards.map(async card => {
          card.stlAvailable = false;
          try {
            const variants = await this.variants(card, cache);
            if (!variants.every(variant => variant?.available)) return;
            this.setPrice(card, variants);
            card.stlAvailable = true;
          } catch { card.stlAvailable = false; }
        }));
        this.applyAvailability();
      }
      async syncCart(cart, sections) {
        if (window.wetheme?.updateCartCount) window.wetheme.updateCartCount(cart);
        if (!sections?.['cart-drawer']) sections = await this.json(this.root + '?sections=cart-drawer');
        if (window.eventBus?.emit && sections?.['cart-drawer']) {
          window.eventBus.emit('update:cart:drawer', { sections });
          window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
        }
      }
      async addLook(card) {
        if (this.busy || this.refreshing || card.hidden) return;
        this.busy = true;
        const button = card.querySelector('button');
        this.cards.forEach(item => { item.querySelector('button').disabled = true; });
        button.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.cartLink.hidden = true;
        let submitted = false;
        let verified = false;
        try {
          const variants = await this.variants(card);
          if (!variants.every(variant => variant?.available)) {
            card.stlAvailable = false;
            this.applyAvailability();
            await this.refresh();
            this.status.textContent = this.dataset.unavailable;
            return;
          }
          this.setPrice(card, variants);
          const before = await this.json(this.root + 'cart.js', { cache: 'no-store' });
          const ids = [card.dataset.plant, card.dataset.pot];
          const quantity = (cart, id) => cart.items.reduce((sum, item) => sum + (String(item.variant_id) === id ? item.quantity : 0), 0);
          submitted = true;
          const result = await this.json(this.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map(id => ({ id: Number(id), quantity: 1 })), sections: 'cart-drawer', sections_url: location.pathname })
          });
          const after = await this.json(this.root + 'cart.js', { cache: 'no-store' });
          verified = ids.every(id => quantity(after, id) >= quantity(before, id) + 1);
          this.status.textContent = verified ? this.dataset.added : this.dataset.uncertain;
          this.cartLink.hidden = false;
          await this.syncCart(after, result.sections);
        } catch {
          this.status.textContent = verified ? this.dataset.added : submitted ? this.dataset.uncertain : this.dataset.error;
          this.cartLink.hidden = !submitted;
          if (submitted && !verified) {
            try { await this.syncCart(await this.json(this.root + 'cart.js', { cache: 'no-store' })); } catch { }
          }
        } finally {
          button.textContent = this.dataset.add;
          this.busy = false;
          this.cards.forEach(item => { item.querySelector('[data-stl-add]').disabled = item.hidden; });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
